import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import LeadsPage from './pages/LeadsPage';
import SubscribersPage from './pages/SubscribersPage';
import DeliveriesPage from './pages/DeliveriesPage';
import SkipsOOTPage from './pages/SkipsOOTPage';
import DeliveryBoysPage from './pages/DeliveryBoysPage';
import PlansPage from './pages/PlansPage';
import PaymentsPage from './pages/PaymentsPage';
import ApartmentsPage from './pages/ApartmentsPage';
import SamplesPage from './pages/SamplesPage';
import NextDayPage from './pages/NextDayPage';
import DeliveryHistoryPage from './pages/DeliveryHistoryPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ImportExportPage from './pages/ImportExportPage';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();
  const [activePanel, setActivePanel] = useState('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#100E0C' }}>
        <div className="text-center">
          <div className="w-10 h-10 rounded-full border-2 border-t-transparent animate-spin mx-auto mb-3" style={{ borderColor: '#C8A96E', borderTopColor: 'transparent' }} />
          <p className="text-sm" style={{ color: '#A8A29E' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  // Delivery boy can only see deliveries
  const effectivePanel = user.role === 'delivery_boy' ? 'deliveries' : activePanel;

  const renderPanel = () => {
    switch (effectivePanel) {
      case 'dashboard': return <Dashboard />;
      case 'leads': return <LeadsPage />;
      case 'subscribers': return <SubscribersPage />;
      case 'deliveries': return <DeliveriesPage />;
      case 'skips': return <SkipsOOTPage />;
      case 'delivery-boys': return <DeliveryBoysPage />;
      case 'plans': return <PlansPage />;
      case 'apartments': return <ApartmentsPage />;
      case 'samples': return <SamplesPage />;
      case 'payments': return <PaymentsPage />;
      case 'next-day': return <NextDayPage />;
      case 'delivery-history': return <DeliveryHistoryPage />;
      case 'import-export': return <ImportExportPage />;
      case 'change-password': return <ChangePasswordPage />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="min-h-screen" style={{ background: '#100E0C' }}>
      <Sidebar activePanel={effectivePanel} setActivePanel={setActivePanel} />
      <main className="md:ml-[260px] min-h-screen">
        <div className="p-6 md:p-8 pt-16 md:pt-8 max-w-7xl">
          {renderPanel()}
        </div>
      </main>
      <InstallPrompt />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
